import { type FilterTypesMap, FilterType } from "utils/filterUtils";
import { type PackName } from "../../../../../interfaces";
import { type FlowBase } from "../../../../../interfaces/flowInfo";
import { type EntityStateProps, type PurchasableContent } from "../../../../../types";

export interface MessageDetails extends EntityStateProps, PurchasableContent {
  body: string;
  callToAction: string;
  destinationUrl: string;
  flows: FlowBase[];
  headline: string;
  imageUrl: string;
  ownerId: number;
  packs: PackName[];
  primaryId: number;
  publisherId: number;
  title: string;
  utmCampaign: string;
}

export enum MessageFiltersEnum {
  DateCreated = "dateCreated",
  DateModified = "dateModified",
}

export const messageFilterTypes: FilterTypesMap<MessageFiltersEnum> = {
  dateCreated: FilterType.DateRange,
  dateModified: FilterType.DateRange,
};

export interface ModalHandlers {
  revert: () => void;
}

// Performance reporting types
export interface MessageLineChart {
  Clicks: number;
  CumulativeClicks: number;
  CumulativeSends: number;
  Date: string;
  Sends: number;
}

export interface MessageEngagement {
  Accounts: number;
  AverageSendSize: number;
  ClickThroughRate: number;
  Messages: number;
  MessagesClicked: number;
  MessagesSent: number;
}

export interface MessageSessionApi {
  MessageId: number;
  SessionId: number;
  SessionDatetime: string; // YYYY-MM-DD HH:mm:ss.SSS
  Status: string; // Sent, InProgress, Failed
  Origin: string; // Flow, Direct
  Sends: number;
  Clicks: number;
  ClickThroughRate: number;
}

export type MessageSession = MessageSessionApi & { id: number };

export interface MessagePerson {
  SendSessionId: number;
  AccountId: number;
  UserId: number;
  UserName: string;
  Email: string;
  Department: string | null;
  JobTitle: string | null;
  SendDate: string | null; // YYYY-MM-DD
  ClickDate: string | null; // YYYY-MM-DD
  Status: string; // Sent, Clicked
}
